export const COPYRIGHT_TEXT =
  `                 Copyright ${new Date().getFullYear()} Westermann
                    Kartenmaterial: Westermann‑Kartographie
                    Produktentwicklung: KST innovations GmbH

                    Diercke Atlas:
                    Projektleitung: Dr. Erik Braune
                    Programmierung Westermann: Stefan Hochmuth
                    Kartographische Umsetzung:
                    Manuela Franke, Florian Kronfeldt
                    Kartographische Bearbeitung:
                    Christian Haack, Harald Iden, Michael Perkovic,
                    Arndt Russ, Henrik Selle, Heiko Strothmann,
                    Sascha Vahlberg, Lars Vonau

                    Diercke Weltatlas (2023):
                    Leitung: Thomas Michael
                    Redaktion: Thomas Michael, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm, Jeremy Wölbling
                    Multimedia‑Redaktion:
                    Dr. Erik Braune, Josephine Strübing
                    Herstellung: Michael Albrecht, Westermann‑Kartographie Umschlaggestaltung: Studio Grau, Berlin
                    Layout und Satz: Westermann‑Kartographie

                    Diercke Weltatlas (2015):
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: Jennifer Kirchhof, Thomas Schröder

                    Diercke Weltatlas 2 – Gesamtausgabe:
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: boje5 Grafik & Werbung, Eckard Schönke, Braunschweig

                    Diercke Weltatlas 2 – Bayern:
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: boje5 Grafik & Werbung, Eckard Schönke, Braunschweig

                    Diercke Weltatlas 2 – Baden-Württemberg:
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: boje5 Grafik & Werbung, Eckard Schönke, Braunschweig

                    Diercke Weltatlas 2 – Nordrhein-Westfalen:
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: boje5 Grafik & Werbung, Eckard Schönke, Braunschweig

                    Diercke Weltatlas 2 – Rheinland-Pfalz:
                    Leitung: Thomas Michael
                    Redaktion: Christian Domdey, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Multimedia-Redaktion:
                    Dr. Erik Braune, Heiko Scholz
                    Kartographische Umsetzung: Michael Albrecht
                    Titelgestaltung: boje5 Grafik & Werbung, Eckard Schönke, Braunschweig

                    Diercke Drei Universalatlas:
                    Leitung: Thomas Michael
                    Redaktion: Thomas Michael, Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Herstellung:
                    Michael Albrecht, Westermann-Kartographie
                    Umschlaggestaltung:
                    boje5 Grafik & Werbung, Eckard Schönke, Braunschweig
                    Layout und Satz: Westermann-Kartographie

                    Diercke International Atlas:
                    Chief Executive: Thomas Michael
                    Editorial: Irene Reitmeier,
                    Björn Richter, Reinhold Schlimm
                    Production: Michael Albrecht, Westermann Kartographie
                    Front cover design:
                    boje5 Grafik & Werbung, Eckard Schönke, Braunschweig
                    Layout and typesetting: Westermann Kartographie`;







